<template>
  <modalWindow v-if="attaching" @close="clearMessage();attaching=false">
    <div class="titlebar">Gebruiker aan portefeuille koppelen</div>
    <div v-if="msg.msg" :class="['form-' + msg.type]">{{ msg.msg }}</div>
    <form @submit.prevent class="inset">
      <input type=text ref="addport" placeholder="Portefeuille">
      <input type=hidden ref="user" placeholder="User">
      <input type=submit @click="addUserPort" value="Portefeuille koppelen">
    </form>
  </modalWindow>
</template>

<script>
export default {
  name: 'UserAttachPort',
  data() {
    return {
      attaching: false,
      msg: { msg: null, type: 'notice' },
    };
  },
  methods: {
    clearMessage() {
      this.msg = { msg: null, type: 'notice' };
    },
    userPort(user) {
      this.attaching = true;
      this.$nextTick(() => {
        this.$refs.user.value = user;
        this.$refs.addport.focus();
      });
    },
    addUserPort() {
      if (this.$refs.addport.value.length < 1) {
        this.msg = { msg: 'Veld moet langer dan 1 karakter', type: 'error' };
      } else {
        this.sdk.addUserPort(
          this.$refs.user.value,
          this.$refs.addport.value,
          (response) => {
            if (response.status === 200) {
              this.$parent.getUsers();
              this.attaching = false;
            } else {
              this.msg = { msg: 'Aanpassing niet verwerkt', type: 'error' };
            }
          },
        );
      }
    },
  },
};
</script>
